import { stringify } from 'qs';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export interface TestLabSourceSlide {
  id: string;
  fileName: string | null;
  sourceStudies: { id: string; name: string }[];
  sourceKind: 'original_upload' | 'permanent_asset' | null;
  canIngest: boolean;
  unavailableReason: string | null;
}

export interface TestLabSourceList {
  slides: TestLabSourceSlide[];
  nextCursor: string | null;
}

export const getTestLabSources = ({
  labId,
  studyId,
  cursor,
  search,
}: {
  labId: string;
  studyId: string;
  cursor?: string;
  search?: string;
}) =>
  apiRequestHandlerPromise<TestLabSourceList>({
    url: `labs/${labId}/test-ingest/sources?${stringify({
      studyId,
      pageSize: 25,
      cursor,
      search: search || undefined,
    })}`,
    method: 'GET',
  });

export const executeTestLabIngest = ({
  labId,
  studyId,
  sourceSlideIds,
}: {
  labId: string;
  studyId: string;
  sourceSlideIds: string[];
}) =>
  apiRequestHandlerPromise<{ jobIds: string[]; failedJobIds: string[]; studyId: string }>({
    url: `labs/${labId}/test-ingest/execute`,
    method: 'POST',
    data: JSON.stringify({ studyId, sourceSlideIds }),
  });
